import postProcessSuggestionsResult from './postProcessSuggestionsResult';
import setFindResultSet from '../setFindResultSet';
import setIsSearching from '../setIsSearching';
import updateFindResultTransactionId from '../updateFindResultTransactionId';
import removeDuplicateResultsFromCacheResults from '../../utils/removeDuplicateResultsFromCacheResults';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import addLocalCacheTransactionComplete from 'owa-recipient-common/lib/utils/addLocalCacheTransactionComplete';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import { action } from 'satcheljs/lib/legacy';

const MAX_RESULTS = 5;

export default action('processCacheResult')(async function processCacheResult(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    cacheResults: PersonaType[],
    recipients: ReadWriteRecipientViewState[],
    appendResults: boolean,
    resolveIfSingle: boolean
): Promise<void> {
    if (appendResults) {
        const currentResultsMap = new Map<string, FindRecipientPersonaType>();
        recipientWell.findResultSet.forEach(value => {
            currentResultsMap[value.EmailAddress.EmailAddress] = value;
        });
        cacheResults = removeDuplicateResultsFromCacheResults(currentResultsMap, cacheResults);

        cacheResults = [...recipientWell.findResultSet, ...cacheResults];
        cacheResults.splice(MAX_RESULTS);
    }

    setIsSearching(recipientWell, false);
    setFindResultSet(recipientWell, cacheResults as FindRecipientPersonaType[]);
    updateFindResultTransactionId(recipientWell);
    addLocalCacheTransactionComplete(recipientWell);
    postProcessSuggestionsResult(recipientWell, recipients, FindResultType.Cache, resolveIfSingle);
});
